import React, { Component } from 'react';
import { Dropdown, Grid, Card } from 'semantic-ui-react';
import { ListEvents } from './graphql.js';
import { updateInPath } from '../../../common/utils';
import { getList } from '../../utils/gqlq.js';
import i18next from 'i18next';
import { clone, map, pipe, find, sortBy, prop } from 'ramda';


class CompetitionFilter extends Component {
  constructor(props) {
    super();

    this.state = {
      events: [],
      loading: false,
      filters: {},
      competitions: []
    };
  }

  fetchData = async () => {
    this.setState(s=> updateInPath(s, 'loading', true));

    const data = await getList('listEvents', { query: ListEvents });

    this.setState(s => updateInPath(s, 'events', sortBy(prop('text'), data)));
    this.setState(s=> updateInPath(s, 'loading', false));
  }

  handleChange = (e, { name, value }) => {
    this.setState(s => updateInPath(s, 'filters.' + name, value));
  }

  handleEventChange = (e, event) => {
    const item = find(({value}) => value === event.value, event.options);

    const competitions = pipe(
      clone(),
      map(c => {
        let itemText = c.code + ' - ';
        itemText += JSON.parse(c.i18n_title)[i18next.language];
        const prop = this.props.textParam;
        
        if (prop && c[prop] !== undefined) {
          itemText += ' (' + c[prop] + ')';
        }
        
        return {
          key: c.id,
          value: c.id,
          code: c.code,
          eventid: event.value,
          text: itemText
        };
      }),
      sortBy(prop('text'))
    )(item.competitions);
    
    this.setState(s => updateInPath(s, 'competitions', competitions));
  }

  handleCompetitionChange = (e, c) => {
    const item = find(({value}) => value === c.value, c.options);

    this.setState(prevState => {
      const newState = clone(prevState);
      newState.filters.competitionId = { eq: c.value };
      this.props.onSubmit(newState.filters, item.eventid);
      return newState;
    });
  };

  componentDidMount = () => {
    this.fetchData();
  }
  
  render() {
    const {
      disabled = false,
      required = false,
      value
    } = this.props;

    const { events, loading } = this.state;

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            Event and Competition/Workshop Filter
          </Card.Header>
          <Card.Description>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Dropdown
                    fluid
                    loading={loading}
                    disabled={disabled}
                    selection
                    placeholder='Select event'
                    required={required}
                    label='Event'
                    value={value}
                    options={events}
                    onChange={this.handleEventChange}/>
                </Grid.Column>
                <Grid.Column width={10}>
                  <Dropdown
                    fluid
                    loading={loading}
                    search
                    disabled={!this.state.competitions.length || disabled}
                    placeholder='Select competition'
                    selection
                    options={this.state.competitions}
                    name='competitionId'
                    onChange={this.handleCompetitionChange} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
};

export default CompetitionFilter;



// WEBPACK FOOTER //
// ./src/public/components/competitionFilter/index.js